import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreateBudgetActions } from './CreateBudgetActions';
import { useNavigate } from 'react-router-dom';

export const EmptyBudgetState: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSuccess = (budgetId: string) => {
    navigate(`/budgets/${budgetId}`);
  };

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center rounded-lg border-2 border-dashed border-slate-300 bg-white p-12 text-center dark:border-surface-600 dark:bg-surface-800">
      <h3 className="mb-2 text-sm font-medium text-slate-900 dark:text-white">
        {t('budget.empty.title')}
      </h3>
      <p className="mb-4 text-sm text-slate-500 dark:text-slate-400">
        {t('budget.empty.description')}
      </p>
      <CreateBudgetActions showText={false} spacing="space-x-2" onSuccess={handleSuccess} />
    </div>
  );
};
